"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartType = void 0;
/**
 * Known names of car parts.
 *
 * *Swagger Schema Reference :* `ReservedPartsNames`
 */
var PartType;
(function (PartType) {
    PartType["IGNORE"] = "ignore";
    PartType["BACKGROUND"] = "background";
    PartType["BUMPER_BACK"] = "bumper_back";
    PartType["BUMPER_FRONT"] = "bumper_front";
    PartType["DOOR_BACK_LEFT"] = "door_back_left";
    PartType["DOOR_BACK_RIGHT"] = "door_back_right";
    PartType["DOOR_FRONT_LEFT"] = "door_front_left";
    PartType["DOOR_FRONT_RIGHT"] = "door_front_right";
    PartType["FENDER_BACK_LEFT"] = "fender_back_left";
    PartType["FENDER_BACK_RIGHT"] = "fender_back_right";
    PartType["FENDER_FRONT_LEFT"] = "fender_front_left";
    PartType["FENDER_FRONT_RIGHT"] = "fender_front_right";
    PartType["FOG_LIGHT_BACK_LEFT"] = "fog_light_back_left";
    PartType["FOG_LIGHT_BACK_RIGHT"] = "fog_light_back_right";
    PartType["FOG_LIGHT_FRONT_LEFT"] = "fog_light_front_left";
    PartType["FOG_LIGHT_FRONT_RIGHT"] = "fog_light_front_right";
    PartType["GRILL"] = "grill";
    PartType["GRILL_LOW"] = "grill_low";
    PartType["GRILL_RADIATOR"] = "grill_radiator";
    PartType["HANDLE_BACK_LEFT"] = "handle_back_left";
    PartType["HANDLE_BACK_RIGHT"] = "handle_back_right";
    PartType["HANDLE_FRONT_LEFT"] = "handle_front_left";
    PartType["HANDLE_FRONT_RIGHT"] = "handle_front_right";
    PartType["HEAD_LIGHT_LEFT"] = "head_light_left";
    PartType["HEAD_LIGHT_RIGHT"] = "head_light_right";
    PartType["HEADER_PANEL"] = "header_panel";
    PartType["HOOD"] = "hood";
    PartType["HOOK"] = "hook";
    PartType["HUBCAP"] = "hubcap";
    PartType["HUBCAP_BACK_LEFT"] = "hubcap_back_left";
    PartType["HUBCAP_BACK_RIGHT"] = "hubcap_back_right";
    PartType["HUBCAP_FRONT_LEFT"] = "hubcap_front_left";
    PartType["HUBCAP_FRONT_RIGHT"] = "hubcap_front_right";
    PartType["INDICATOR_LIGHT_LEFT"] = "indicator_light_left";
    PartType["INDICATOR_LIGHT_RIGHT"] = "indicator_light_right";
    PartType["LICENSE_PLATE_BACK"] = "license_plate_back";
    PartType["LICENSE_PLATE_FRONT"] = "license_plate_front";
    PartType["LOGO"] = "logo";
    PartType["MIRROR_SUPPORT"] = "mirror_support";
    PartType["MIRROR_LEFT"] = "mirror_left";
    PartType["MIRROR_RIGHT"] = "mirror_right";
    PartType["PETROL_DOOR"] = "petrol_door";
    PartType["PILLAR"] = "pillar";
    PartType["QUARTER_WINDOW_BACK_LEFT"] = "quarter_window_back_left";
    PartType["QUARTER_WINDOW_BACK_RIGHT"] = "quarter_window_back_right";
    PartType["QUARTER_WINDOW_FRONT_LEFT"] = "quarter_window_front_left";
    PartType["QUARTER_WINDOW_FRONT_RIGHT"] = "quarter_window_front_right";
    PartType["REAR_SPOILER"] = "rear_spoiler";
    PartType["ROCKER_PANEL"] = "rocker_panel";
    PartType["ROCKER_PANEL_LEFT"] = "rocker_panel_left";
    PartType["ROCKER_PANEL_RIGHT"] = "rocker_panel_right";
    PartType["ROOF"] = "roof";
    PartType["TAIL_LIGHT_CENTER"] = "tail_light_center";
    PartType["TAIL_LIGHT_LEFT"] = "tail_light_left";
    PartType["TAIL_LIGHT_RIGHT"] = "tail_light_right";
    PartType["TRUNK"] = "trunk";
    PartType["TURN_SIGNAL_FRONT_LATERAL_LEFT"] = "turn_signal_front_lateral_left";
    PartType["TURN_SIGNAL_FRONT_LATERAL_RIGHT"] = "turn_signal_front_lateral_right";
    PartType["WHEEL_BACK_LEFT"] = "wheel_back_left";
    PartType["WHEEL_BACK_RIGHT"] = "wheel_back_right";
    PartType["WHEEL_FRONT_LEFT"] = "wheel_front_left";
    PartType["WHEEL_FRONT_RIGHT"] = "wheel_front_right";
    PartType["WINDOW_BACK_LEFT"] = "window_back_left";
    PartType["WINDOW_BACK_RIGHT"] = "window_back_right";
    PartType["WINDOW_CORNER_LEFT"] = "window_corner_left";
    PartType["WINDOW_CORNER_RIGHT"] = "window_corner_right";
    PartType["WINDOW_FRONT_LEFT"] = "window_front_left";
    PartType["WINDOW_FRONT_RIGHT"] = "window_front_right";
    PartType["WINDSHIELD_BACK"] = "windshield_back";
    PartType["WINDSHIELD_FRONT"] = "windshield_front";
    PartType["WIPER"] = "wiper";
    PartType["WIPER_BACK"] = "wiper_back";
    PartType["WIPER_FRONT"] = "wiper_front";
    PartType["WHEEL"] = "wheel";
})(PartType = exports.PartType || (exports.PartType = {}));
//# sourceMappingURL=entityTypes.js.map